import React, { useState, useEffect,useContext } from 'react';
import bgImg from '../images/login-backgrd.jpeg';
import { useHistory } from 'react-router-dom'; 
import {fetchGetProfile,fetchUpdateProfile} from './Api'
import { Contextone } from './Context';
import Cookies from 'js-cookie';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';



const Profile = () => {
    const [userData, setUserData] = useState({});
    const [isEditing, setIsEditing] = useState(false); 
    const[isName, setIsName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [isEmail, setIsEmail] = useState("");
    const [isPassword, setIsPassword] = useState("");
    const [phoneError, setPhoneError] = useState('');
    const history = useHistory();
    const countercontext = useContext(Contextone);
    const isurl = countercontext.isDomain;
    const apiUrl = `https://${isurl}`;
    
    const goBack = () => {
        if(isEditing){
            setIsEditing(false);
        }
        else{
            history.goBack();
        }
    };
    const uid = Cookies.get('userid');
    const handleEditClick = () => {
        setIsName(userData.name || "");
        // setIsEmail(userData.email || "");
        // setPhoneNumber(userData.mobile || "");
        // setPhoneNumber(userData.mobile ? userData.mobile.replace("+91", "") : "");
        setIsEditing(true);
    };

    let num;
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                 
                const data = await fetchGetProfile(apiUrl,uid);
                setUserData(data.result[0]);
                
            } catch (error) {
                console.error('Error:', error);
            }
        };
  
        fetchProfile();
    }, [uid]);

    const fetchDetail = async (uid,phoneNumber,email,isName) => {
        try {
            // num = '+91' + phoneNumber;
            const data = await fetchUpdateProfile(apiUrl,uid,phoneNumber,email,isName);
            setUserData(data.result[0]);
        } catch (error) {
            console.error('Error:', error);
        }
    };    
    // mobile and email also edit 
    const handleSaveClick = async () => {
        if (phoneNumber.length === 10 && !(/^[0-5]/.test(phoneNumber))) {
            if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(isEmail)) {
                setIsEditing(false);
                fetchDetail(uid,phoneNumber,isEmail,isName)
                num = '+91' + phoneNumber;
            } else {
                alert('Invalid email address. Please enter a valid email.');
            }
        } else {
            setPhoneError('Mobile number must be 10 digits long.');
            alert('Invalid Number');
        }
    };
    // only name
    const handleSave = async () => {
        setIsEditing(false);
        fetchDetail(uid,userData.mobile,userData.email,isName)
        // num = '+91' + phoneNumber;
    };

    const handleNameChange = (e) => {
        const value = e.target.value;
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setIsName(value);
        }
    };
    const handleEmailChange = (e) => {
        const value = e.target.value;
        if (/^[a-zA-Z0-9@.]*$/.test(value)) {
            setIsEmail(value);
        }
    };
    const handleMobileChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && value.length <= 10) {
            setPhoneNumber(value);
        }
    };
    
    return (
        <div className="signin-container">
           
            <div className="signin-background">
                <img src={bgImg} alt="Background" className="background-image" />
            </div>
            
            <div className="profile-container">
            <div className="top-left-button">
                <button onClick={goBack} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#000', cursor: 'pointer' }}>
                    <FontAwesomeIcon icon={faArrowLeft} style={{ color: 'white' }} />
                </button>
            </div>
                <h2 style={{ color: 'red', textAlign: 'center', marginLeft:'10px',color:'#DEEB52'}}>Profile</h2>
                <div className="profile-details">
                    <div className="profile-detail">
                        <label>Name:</label>
                        {isEditing ? (
                            <input
                                className='input-name'
                                type="text"
                                name="name"
                                value={isName}
                                onChange={handleNameChange}
                            />
                        ) : (
                            <span>{userData.name}</span>
                        )}
                    </div>
                    {userData.email &&
                    <div className="profile-detail">
                        <label>Email:</label>
                        <span  className='emailmargin'>{userData.email}</span>
                    </div>}
                    {userData.mobile && 
                    <div className="profile-detail">
                        <label>Mobile:</label>
                        <span>{userData.mobile}</span>
                    </div>}
                </div>
                
                {isEditing ? (
                    <button className="edit-button" onClick={handleSave}>Save</button>
                ) : (
                    <button className="edit-button" onClick={handleEditClick}>Edit</button>
                )}
            </div>
        </div>
    );
};
export default Profile;

// import React, { useState, useEffect,useContext } from 'react';
// import bgImg from '../images/login-backgrd.jpeg';
// import { useHistory } from 'react-router-dom'; 
// import {fetchGetProfile,fetchUpdateProfile} from './Api'
// import { Contextone } from './Context';
// import Cookies from 'js-cookie';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';



// const Profile = () => {
//     const [userData, setUserData] = useState({});
//     const [isEditing, setIsEditing] = useState(false); 
//     const[isName, setIsName] = useState("");
//     const [phoneNumber, setPhoneNumber] = useState("");
//     const [isEmail, setIsEmail] = useState("");
//     const [isPassword, setIsPassword] = useState("");
//     const [phoneError, setPhoneError] = useState('');
//     const history = useHistory();
//     const countercontext = useContext(Contextone);
//     const isurl = countercontext.isDomain;
//     const apiUrl = `https://${isurl}`;
    
//     const goBack = () => {
//         if(isEditing){
//             setIsEditing(false);
//         }
//         else{
//             history.goBack();
//         }
//     };
//     const uid = Cookies.get('userid');
//     const handleEditClick = () => {
//         setIsName(userData.name || "");
//         setIsEmail(userData.email || "");
//         setPhoneNumber(userData.mobile || "");
//         setPhoneNumber(userData.mobile ? userData.mobile.replace("+91", "") : "");
//         setIsEditing(true);
//     };

//     let num;
//     useEffect(() => {
//         const fetchProfile = async () => {
//             try {
                 
//                 const data = await fetchGetProfile(apiUrl,uid);
//                 setUserData(data.result[0]);
                
//             } catch (error) {
//                 console.error('Error:', error);
//             }
//         };
  
//         fetchProfile();
//     }, [uid]);

//     const fetchDetail = async (uid,phoneNumber,email,isName) => {
//         try {
//             num = '+91' + phoneNumber;
//             const data = await fetchUpdateProfile(apiUrl,uid,num,email,isName);
//             setUserData(data.result[0]);
//         } catch (error) {
//             console.error('Error:', error);
//         }
//     };    

//     const handleSaveClick = async () => {
//         if (phoneNumber.length === 10 && !(/^[0-5]/.test(phoneNumber))) {
//             if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(isEmail)) {
//                 setIsEditing(false);
//                 fetchDetail(uid,phoneNumber,isEmail,isName)
//                 num = '+91' + phoneNumber;
//             } else {
//                 alert('Invalid email address. Please enter a valid email.');
//             }
//         } else {
//             setPhoneError('Mobile number must be 10 digits long.');
//             alert('Invalid Number');
//         }
//     };

//     const handleNameChange = (e) => {
//         const value = e.target.value;
//         if (/^[a-zA-Z\s]*$/.test(value)) {
//             setIsName(value);
//         }
//     };
//     const handleEmailChange = (e) => {
//         const value = e.target.value;
//         if (/^[a-zA-Z0-9@.]*$/.test(value)) {
//             setIsEmail(value);
//         }
//     };
//     const handleMobileChange = (e) => {
//         const value = e.target.value;
//         if (/^\d*$/.test(value) && value.length <= 10) {
//             setPhoneNumber(value);
//         }
//     };
    

//     return (
//         <div className="signin-container">
           
//             <div className="signin-background">
//                 <img src={bgImg} alt="Background" className="background-image" />
//             </div>
            
//             <div className="profile-container">
//             <div className="top-left-button">
//                 <button onClick={goBack} style={{ background: 'none', border: 'none', fontSize: '24px', color: '#000', cursor: 'pointer' }}>
//                     <FontAwesomeIcon icon={faArrowLeft} style={{ color: 'white' }} />
//                 </button>
//             </div>
//                 <h2 style={{ color: '#DEEB52', textAlign: 'center', marginLeft:'10px' }}>Profile</h2>
//                 <div className="profile-details">
//                     <div className="profile-detail">
//                         <label>Name:</label>
//                         {isEditing ? (
//                             <input
//                                 className='input-name'
//                                 type="text"
//                                 name="name"
//                                 value={isName}
//                                 onChange={handleNameChange}
//                             />
//                         ) : (
//                             <span>{userData.name}</span>
//                         )}
//                     </div>
//                     <div className="profile-detail">
//                         <label>Email:</label>
//                         {isEditing ? (
//                             <input
//                                 className='input-email'
//                                 type="text"
//                                 name="email"
//                                 value={isEmail}
//                                 onChange={handleEmailChange}
//                             />
//                         ) : (
//                             <span  className='emailmargin'>{userData.email}</span>
//                         )}
//                     </div>
//                     <div className="profile-detail">
//                         <label>Mobile:</label>
//                         {isEditing ? (
//                             <input
//                                 className='input-mobile'
//                                 type="text"
//                                 name="mobile"
//                                 value={phoneNumber}
//                                 onChange={handleMobileChange}
//                                 maxLength={10}
//                             />
//                         ) : (
//                             <span>{userData.mobile}</span>
//                         )}
//                     </div>
//                 </div>
                
//                 {isEditing ? (
//                     <button className="edit-button" onClick={handleSaveClick}>Save</button>
//                 ) : (
//                     <button className="edit-button" onClick={handleEditClick}>Edit</button>
//                 )}
//             </div>
//         </div>
//     );
// };
// export default Profile;